/**
 * Created by lu on 2018/4/16.
 */
var nb = require('../../../nb');
module.exports = nb.define({
    parent: require('../../../model/control/Model'),
    mapping: {
        content: require('./Content')
    },
    method: {
        init: function () {
            this.set('activeLi', {
                index: 3
            });
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/page/order/model/Model.js
// module id = 677
// module chunks = 3